module.exports = __webpack_public_path__ + "img/notificacaoFill.cb913f46.svg";